import React, { useEffect } from 'react';

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectFirebaseInfo } from '_redux/slices/main-screen/user';
import { selectTimelineDate } from '_redux/slices/timeline/timeline-control';
import { getAirportLocationsAnalytics, selectSelectedDashboardLocation, setSelectedDashboardLocation } from '_redux/slices/timeline/timeline-dashboard';
import { selectAirportLocations } from '_redux/slices/timeline/timeline-areas';

// custom components
import { LocationCard, LiveFlightTimesCard } from '_organisms';
import LiveTracker from './live-tracker';

// bootstrap
import { Col, Row } from 'react-bootstrap';

// functions
import { getDate } from "_utils/functions";

// tremor 
import { Title as TremorTitle, Subtitle } from '@tremor/react';

const CurrentOperation = () => {
    //#region redux
    const dispatch = useDispatch();

    const dbUser = useSelector(selectFirebaseInfo);
    const timelineDate = useSelector(selectTimelineDate);                                 // select timeline Date
    const selectedDashboardLocation = useSelector(selectSelectedDashboardLocation);       // select dashboard location
    const airportLocations = useSelector(selectAirportLocations);                                   // select all airport locations

    //#endregion

    //#region useEffect

    // at first render set the selected dashboard airport location to teh first element of the airportLocations array
    useEffect(() => {
        if (Array.isFullArray(airportLocations)) {
            let firstLocation = airportLocations?.[0]?._id;
            if (firstLocation) dispatch(setSelectedDashboardLocation(firstLocation));
        }
    }, [])

    // get airport locations analytics when component mounts and when timelineDate changes
    useEffect(() => {
        const date = getDate(timelineDate);
        if (date && selectedDashboardLocation) {
            dispatch(getAirportLocationsAnalytics({
                iata: dbUser.details.authority,
                locationId: selectedDashboardLocation,
                start: date,
                end: date,
                limit: 5,
                skip: 0
            }))
        }
    }, [timelineDate, selectedDashboardLocation]);
    //#endregion

    // for development
    const borderWidth = 0;

    return (

        <Row>

            {/* title */}
            <Row>
                <TremorTitle>{'Current Operation'}</TremorTitle><Subtitle>{'View current activity in your airport'}</Subtitle>
            </Row>
            
            <Row style={{
                borderStyle: 'solid', borderWidth: borderWidth,
                display: 'flex',
                flex: 1
            }}>

                {/* location component */}
                <Col xs={3}>
                    <LocationCard />
                </Col>

                <Col xs={3}>
                    <LiveFlightTimesCard />
                </Col>

                <Col>
                    <LiveTracker />
                </Col>

            </Row>

        </Row>
    );
};

export default CurrentOperation;
